export default function RoadmapBlock() {
  return (
    <>
      <path
        d="M906.37 47H50.63C37.5795 47 27 57.5795 27 70.63V244.37C27 257.42 37.5795 268 50.63 268H906.37C919.42 268 930 257.42 930 244.37V70.63C930 57.5795 919.42 47 906.37 47Z"
        fill="#17074B"
      />
      <path
        d="M414.3 250.39L376.85 260.92C374.295 261.638 371.654 262.002 369 262H50.49C44.2625 261.992 38.2923 259.515 33.8888 255.111C29.4853 250.708 27.0079 244.738 27 238.51V240.51C27 246.74 29.4748 252.715 33.8801 257.12C38.2853 261.525 44.2601 264 50.49 264H371.67L373 265L414.3 250.39Z"
        fill="#111C44"
      />
      <path
        d="M414.3 61.61L376.85 51.08C374.295 50.3617 371.654 49.9982 369 50H50.49C44.2625 50.0079 38.2923 52.4853 33.8888 56.8888C29.4853 61.2923 27.0079 67.2625 27 73.49V71.49C27 65.2601 29.4748 59.2853 33.8801 54.8801C38.2853 50.4748 44.2601 48 50.49 48H371.67L373 47L414.3 61.61Z"
        fill="#111C44"
      />
      <path
        d="M546.7 61.61L584.15 51.08C586.705 50.3617 589.346 49.9982 592 50H910.51C916.737 50.0079 922.708 52.4853 927.111 56.8888C931.515 61.2923 933.992 67.2625 934 73.49V71.49C934 65.2601 931.525 59.2853 927.12 54.8801C922.715 50.4748 916.74 48 910.51 48H589.33L588 47L546.7 61.61Z"
        fill="#111C44"
      />
      <path
        d="M906.51 262H589.3C586.646 262.001 584.005 261.637 581.45 260.92L544 250.39L585.3 265L586.77 263.9L587.1 264H906.51C912.74 264 918.715 261.525 923.12 257.12C927.525 252.715 930 246.74 930 240.51V238.51C929.992 244.738 927.515 250.708 923.111 255.111C918.708 259.515 912.738 261.992 906.51 262Z"
        fill="#111C44"
      />
      <path
        opacity="0.64"
        d="M934 47H27V119H934V47Z"
        fill="url(#paint0_radial_241_1629)"
      />
      <path
        opacity="0.64"
        d="M931 262L27 265V191H934L931 262Z"
        fill="url(#paint1_radial_241_1629)"
      />
      <path
        opacity="0.64"
        d="M934 119H27V191H934V119Z"
        fill="url(#paint2_radial_241_1629)"
      />
      <g filter="url(#filter0_d_241_1629)">
        <path
          d="M904.51 35H52.51C47.4537 34.9974 42.4465 35.991 37.7744 37.9241C33.1022 39.8573 28.8568 42.692 25.2805 46.2664C21.7043 49.8408 18.8673 54.0848 16.9318 58.7559C14.9962 63.427 14 68.4337 14 73.49L14 236.49C14 257.77 30.23 277 51.49 277H903.49C924.75 277 942.98 257.77 942.98 236.51V73.51C942.983 68.4554 941.99 63.4498 940.058 58.779C938.126 54.1082 935.293 49.8636 931.721 46.2876C928.148 42.7116 923.907 39.8743 919.238 37.9375C914.569 36.0008 909.565 35.0026 904.51 35ZM541.51 49.9L498.51 63.75C485.875 67.8102 472.285 67.8102 459.65 63.75L416.65 49.9C416.451 49.8055 416.289 49.648 416.189 49.4519C416.089 49.2559 416.056 49.0322 416.096 48.8157C416.136 48.5992 416.246 48.4018 416.409 48.2544C416.573 48.1069 416.781 48.0175 417 48H541.22C541.436 48.0262 541.637 48.1221 541.794 48.2731C541.95 48.4241 542.053 48.622 542.087 48.8368C542.121 49.0516 542.084 49.2716 541.982 49.4634C541.879 49.6553 541.717 49.8086 541.52 49.9H541.51ZM532.81 264H425.35C424.876 263.997 424.418 263.825 424.059 263.515C423.699 263.205 423.462 262.778 423.388 262.309C423.315 261.84 423.411 261.361 423.658 260.956C423.906 260.552 424.289 260.248 424.74 260.1L459.34 249C472.179 244.87 485.991 244.87 498.83 249L533.43 260.14C533.856 260.306 534.211 260.613 534.438 261.01C534.665 261.407 534.749 261.869 534.677 262.32C534.604 262.771 534.38 263.184 534.04 263.49C533.7 263.795 533.266 263.975 532.81 264ZM930 238.51C930 245.27 927.314 251.754 922.534 256.534C917.754 261.314 911.27 264 904.51 264H589.64C587.96 264 586.29 263.74 584.69 263.23L580.82 262L498.71 235.85C485.943 231.786 472.227 231.804 459.47 235.9L378.12 262L374.75 263.08C372.85 263.69 370.866 264 368.87 264H52.49C45.7296 264 39.2462 261.314 34.4658 256.534C29.6855 251.754 27 245.27 27 238.51V72.51C26.9934 69.2928 27.6216 66.106 28.8485 63.1319C30.0754 60.1579 31.877 57.4551 34.15 55.1783C36.423 52.9016 39.1229 51.0956 42.0949 49.8638C45.067 48.632 48.2528 47.9987 51.47 48H361.47C367.146 47.999 372.787 48.883 378.19 50.62L459.81 76.81C472.37 80.825 485.87 80.825 498.43 76.81L579.32 51.05C585.75 49.0169 592.456 47.9881 599.2 48H905.53C908.744 47.9987 911.926 48.6307 914.896 49.86C917.865 51.0893 920.563 52.8917 922.836 55.1642C925.108 57.4367 926.911 60.1348 928.14 63.1042C929.369 66.0736 930.001 69.2562 930 72.47V238.51Z"
          fill="#21369C"
        />
      </g>
      <path
        d="M478 64C481.314 64 484 61.3137 484 58C484 54.6863 481.314 52 478 52C474.686 52 472 54.6863 472 58C472 61.3137 474.686 64 478 64Z"
        fill="#27357B"
      />
      <path
        d="M478 261C481.314 261 484 258.314 484 255C484 251.686 481.314 249 478 249C474.686 249 472 251.686 472 255C472 258.314 474.686 261 478 261Z"
        fill="#27357B"
      />
      <g filter="url(#filter1_f_241_1629)">
        <ellipse
          cx="458"
          cy="164.5"
          rx="218"
          ry="63.5"
          fill="#0A002B"
          fillOpacity="0.3"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_241_1629"
          x="0.9"
          y="25.9"
          width="955.18"
          height="268.2"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="6.55" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_241_1629"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_241_1629"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_f_241_1629"
          x="139.3"
          y="0.300003"
          width="637.4"
          height="328.4"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="50.35"
            result="effect1_foregroundBlur_241_1629"
          />
        </filter>
        <radialGradient
          id="paint0_radial_241_1629"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(234.62 74.09) scale(247.31 247.31)"
        >
          <stop stopColor="#190F63" stopOpacity="0.8" />
          <stop offset="1" stopColor="#17074B" />
        </radialGradient>
        <radialGradient
          id="paint1_radial_241_1629"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(480.5 228.43) scale(321.68 331.33)"
        >
          <stop stopColor="#190D5C" />
          <stop offset="0.95" stopColor="#17074C" />
          <stop offset="1" stopColor="#17074B" />
        </radialGradient>
        <radialGradient
          id="paint2_radial_241_1629"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(725.09 150.45) scale(355.78 355.78)"
        >
          <stop offset="0.08" stopColor="#170758" />
          <stop offset="0.43" stopColor="#170751" />
        </radialGradient>
      </defs>
    </>
  );
}
